import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vi-chart" }

import { computed } from "vue";


import { Bar } from "vue-chartjs";
import { Chart as ChartJS } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { Title } from "chart.js";
import { Legend } from "chart.js";
import { Tooltip } from "chart.js";
import { BarElement } from "chart.js";
import { LinearScale } from "chart.js";
import { CategoryScale } from "chart.js";


export default /*@__PURE__*/_defineComponent({
  __name: 'vi-bar-chart',
  props: {
    indexAxis: {},
    barThickness: {},
    scales: {},
    data: {},
    options: {}
  },
  setup(__props: any) {

const props = __props;

const defaultOptions = {
  responsive: true,
  indexAxis: "x",
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  title: {
    display: false,
  },
  barThickness: 160,
};

const scales = computed(() => {
  const indexAxis = props.indexAxis ?? defaultOptions.indexAxis;
  let y = {
    ticks: {
      stepSize: 25,
      color: "#272740",
      font: {
        size: 12,
      },
    },
    grid: {
      drawOnChartArea: indexAxis !== "y",
    },
  };
  if (indexAxis === "x") {
    y.min = props.scales.y.min;
    y.max = props.scales.y.max;
    y.ticks.callback = (value) => {
      return [0, 50, 100].includes(value) ? value : "";
    };
  }

  const x = {
    ticks: {
      stepSize: 25,
      color: "#272740",
      font: {
        size: 12,
      },
    },
    grid: {
      drawOnChartArea: indexAxis !== "x",
    },
  };
  if (indexAxis === "y") {
    x.min = props.scales.x?.min;
    x.max = props.scales.x?.max;
    x.ticks.callback = (value) => {
      return [-100, 0, 100].includes(value) ? value : "";
    };
  }

  return { x, y };
});

const options = {
  ...defaultOptions,
  barThickness: props.barThickness ?? defaultOptions.barThickness,
  indexAxis: props.indexAxis,
  scales: scales.value,
  ...(props.options ? props.options : {}),
};

ChartJS.register(
  Title,
  Legend,
  Tooltip,
  BarElement,
  LinearScale,
  CategoryScale,
  ChartDataLabels,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Bar), {
      "chart-data": props.data,
      "chart-options": options
    }, null, 8, ["chart-data"])
  ]))
}
}

})